<obp-timeline
              [Items]="items"
              [Groups]="groups"
              (SelectedItemChange)="OnItemSelect($event)"
              (ItemDoubleClick)="OnItemDoubleClick($event)"
              (GroupDoubleClick)="OnGroupDoubleClick($event)"
              >
</obp-timeline>
